import React from 'react';
import { connect } from 'react-redux';
import { formerApi } from '../../api';

function withApi(CurrentComponent, options = {}) {
  class withApiInternal extends React.Component {
    componentWillUnmount() {
      const { cancelOnUnmount } = options;

      if (cancelOnUnmount) {
        this.cancel();
      }
    }

    cancel() {
      const { tasks } = this;
      tasks.forEach(({ abortController }) => abortController.abort('Task cancelled by api HOC'));
    }

    render() {
      const { props } = this;
      const {
        language,
        timeZone
      } = props;

      const outputApi = {};
      const tasks = [];
      this.tasks = tasks;

      Object.keys(formerApi).forEach(currentApiName => {
        const currentApi = formerApi[currentApiName];
        const currentApiKeys = Object.keys(currentApi);
        const currentApiFunctionNames = currentApiKeys.filter(method => typeof (currentApi[method]) === 'function');

        const result = {};
        currentApiFunctionNames.forEach(name => {
          result[name] = async function (...args) {
            const abortController = new AbortController();

            args.push(language);
            args.push(timeZone);
            args.push(abortController.signal);

            const request = currentApi[name].apply(null, args);

            tasks.push({
              request,
              abortController
            });

            return request;
          };
        });
        outputApi[currentApiName] = result;
      });

      outputApi.cancel = () => {
        this.cancel();
      };

      const newProps = Object.assign({}, props, { api: outputApi });

      return (<CurrentComponent {...newProps} />);
    }
  }

  return connect(({ language, timeZone }) => ({ language, timeZone }))(withApiInternal);
}

export default withApi;
